import { CSSProperties } from 'react';

const borderStyle = 'solid rgba(34, 36, 38, .1)';

export const featureStyle = { margin: '0.5em 0', textAlign: 'left', padding: '1em 0' };

export const makeBorderStyle = (side: string = '', size: number = 1) => ({
  [`border${side}`]: `${size}px ${borderStyle}`,
});

export const btnDownloadStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
};

export const bucketSelectedStyle = { backgroundColor: '#F3F1F1' };
